export const CUSTOM_RANGE = "Custom Range";
